import { Observable } from "rxjs";
import { ModuleName } from "../enums/module-name";

export abstract class SubscriptionPackageService {
    public abstract getInternalWorkerAllowedModules(): Observable<ModuleName[]>;
    public abstract getExternalWorkerAllowedModules(): Observable<ModuleName[]>;
    public abstract getExternalWorkerAllowedModulesForWorker(workerId?: number): Observable<ModuleName[]>;
}